import { createAction, props } from '@ngrx/store';

import { Barn } from '../../models/barn.model';

/** BARN SETTING ACTIONS */
export const loadBarnsRequest = createAction('[Barn] Load barns request');
export const loadBarnsSuccess = createAction(
  '[Barn] Load barns success',
  props<{ barns: Barn[] }>(),
);
export const loadBarnsFailed = createAction('[Barn] Load barns failed', props<{ error: Error }>());

export const upsertBarnRequest = createAction(
  '[Barn] Upsert barn request',
  props<{ barn: Barn }>(),
);
export const upsertBarnSuccess = createAction(
  '[Barn] Upsert barn success',
  props<{ barn: Barn }>(),
);
export const upsertBarnFailed = createAction(
  '[Barn] Upsert barn failed',
  props<{ error: Error }>(),
);

export const deleteBarnRequest = createAction(
  '[Barn] Delete barn request',
  props<{ barn: Barn }>(),
);
export const deleteBarnWithConfirmation = createAction(
  '[Barn] Confirm Delete barn',
  props<{ barn: Barn }>(),
);
export const deleteBarnSuccess = createAction(
  '[Barn] Delete barn success',
  props<{ barn: Barn }>(),
);
export const deleteBarnFailed = createAction(
  '[Barn] Delete barn failed',
  props<{ error: Error }>(),
);

export const upsertBarn = createAction('[Barn] Upsert barn', props<{ barn: Barn }>());
export const setSelectedBarn = createAction(
  '[Barn] Set Selected barn',
  props<{ barnId?: number }>(),
);
